import { render, staticRenderFns } from "./CitationModal.vue?vue&type=template&id=421088b6"
import script from "./CitationModal.vue?vue&type=script&lang=js"
export * from "./CitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports